export const ImportTableLabelTextHelper = {
    getLabelText: {
        status: 'Import Status',
        error: 'Import Error',
        result: 'Import Result'
    },
    getImportResultValue: {
        initial: 'pending',
        success: 'success',
        skipped: 'skipped',
        error: 'error'
    }
};
